import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { DateRange } from '@angular/material/datepicker';
import { startOfMonth } from 'date-fns';
// import moment, { Moment } from 'moment';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { convertDateTimeFormat } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
})
export class DateRangeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  formGroup!: FormGroup;
  submited = false;
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  datePicker = new DateRange(null, null); //default range format

  constructor(
    public rootFormGroup: FormGroupDirective,
    private _dateAdapter: DateAdapter<dateFns>
  ) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.datePicker = this.formGroup.controls.dateTodateFrom.value;
  }
  /**
   * @description validate form if form valid hold value into main form and redirect to next step
   * @returns void
   */
  submit(): void {
    this.submited = true;
    this.updateForm(this.datePicker as unknown as any);
    this.stepperChange.emit((this.stepper = 1));
  }

  updateForm(date: DateRange<dateFns>) {
    this.formGroup.patchValue({
      dateTodateFrom: date,
    });
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
  }
}
